<ng-template #journal>
    <div body>
        <div class="actions-table">
            <div class="journal-record" *ngFor="let record of viewModel?.records">
                <div class="desc-column">
                    <div class="record-text-wrapper" *ngIf="record.claimStatus">
                        {{'Screens.Patients.InfoWidget.PatientJournal.ClaimCreated' | translate }} -
                        {{ 'Enumerations.ClaimStatusEnum.' + record.claimStatus | translate }} -
                        {{ record.claimInsurancePlanName }}
                    </div>
                    <div class="record-text-wrapper" *ngIf="record.paymentAmount != null">
                        <div class="record-text-wrapper">
                            {{'Screens.Patients.InfoWidget.PatientJournal.Payment' | translate }} -
                            {{ record.paymentAmount | wafCurrency }}
                        </div>
                    </div>
                    <div class="record-text-wrapper" *ngIf="record.saleOrderStatus">
                        <a *ngIf="canReadSaleOrder" target="_blank" [routerLink]="['/sales-orders/details']"
                           [queryParams]="{id: record.salesOrderId, isPatientReadonly: true}">
                            {{ 'Common.SearchColumnsAndDetailsFields.SalesOrder' | translate }} -
                            {{ 'Enumerations.OrderStatusEnum.' + record.saleOrderStatus | translate}}</a>
                        <div *ngIf="!canReadSaleOrder" class="record-text-wrapper">
                            {{ 'Common.SearchColumnsAndDetailsFields.SalesOrder' | translate }} -
                            {{ 'Enumerations.OrderStatusEnum.' + record.saleOrderStatus | translate }}
                        </div>
                    </div>
                    <div class="record-text-wrapper" *ngIf="record.invoiceDocumentId">
                        <a *ngIf="canReadInvoices" (click)="onAttachmentClick($event, record.invoiceDocumentId)"
                           class="file-link">
                            {{'Screens.Patients.InfoWidget.PatientJournal.InvoiceCreated' | translate }}</a>
                        <div *ngIf="!canReadInvoices" class="record-text-wrapper">
                            {{'Screens.Patients.InfoWidget.PatientJournal.InvoiceCreated' | translate }}
                        </div>
                    </div>
                    <div class="record-text-wrapper" *ngIf="record.noteId">
                        <a *ngIf="canReadNotes"
                           [routerLink]="['/patients/details/note-details', {mode: 'modal', size: 'lg'}]"
                           [queryParams]="{id: record.noteId, patientId: requestModel.patientId}">
                            {{ record.noteSubject }}</a>
                        <div *ngIf="!canReadNotes" class="record-text-wrapper">
                            {{ record.noteSubject }}
                        </div>
                    </div>
                    <div class="record-text-wrapper" *ngIf="record.hearngAidStyleName">
                        <a *ngIf="canReadSaleOrder" target="_blank" [routerLink]="['/sales-orders/details']"
                           [queryParams]="{id: record.salesOrderId, isPatientReadonly: true}">
                            {{ record.hearngAidStyleName }} -
                            {{ 'Screens.Patients.InfoWidget.PatientJournal.ProductStylePosition.' +
                            (record.productStylePosition == 1 ? 'Right' : 'Left') | translate }} -
                            {{ (record.hearingAidDelivered ?
                            'Screens.Patients.InfoWidget.PatientJournal.Fulfilled' :
                            'Screens.Patients.InfoWidget.PatientJournal.PutOnTrial') | translate }}</a>
                            <span *ngIf="!canReadSaleOrder">
                                {{ record.hearngAidStyleName }} -
                                {{ 'Screens.Patients.InfoWidget.PatientJournal.ProductStylePosition.' +
                            (record.productStylePosition == 1 ? 'Right' : 'Left') | translate }} -
                                {{ (record.hearingAidDelivered ?
                            'Screens.Patients.InfoWidget.PatientJournal.Fulfilled' :
                            'Screens.Patients.InfoWidget.PatientJournal.PutOnTrial') | translate }}
                            </span>
                        </div>
                    </div>
                    <div class="date-column">
                        {{ record.date | wafShortDate }}
                    </div>
                </div>
            </div>
        </div>
        <search-paging *ngIf="!isPreview" [search]="searchInstance"></search-paging>
</ng-template>

<tcm-main-frame *ngIf="!isPreview" titleKey="Screens.Patients.InfoWidget.PatientJournal.Title">
    <ng-container commands>
        <button type="button" class="btn btn-default"
                (click)="goBack()">{{"Common.SearchActionsAndDetailsActions.Back" | translate}}</button>
    </ng-container>
    <ng-container body>
        <div class="tcm-panel">
            <ng-container [ngTemplateOutlet]="journal"></ng-container>
        </div>
    </ng-container>
</tcm-main-frame>

<div *ngIf="isPreview">
    <ng-container [ngTemplateOutlet]="journal"></ng-container>
</div>